const UserCenter = () => import('@/views/user-center/user-center.vue');

const useRouter = {
  name: 'user-cener',
  path: '/user-center',
  component: UserCenter,
  meta: {
    title: '个人中心',
  }
};

export default useRouter;
